import { DrawerFooter } from '@chakra-ui/react'

export default DrawerFooter
